
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/toolkits/search",
      function () {
        return require("private-next-pages/toolkits/search.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/toolkits/search"])
      });
    }
  